const companyEndpoints = {
  list: '/companies'
}

export default companyEndpoints
